module.exports = __webpack_public_path__ + "assets/icon-demographic-profile-component.fe384102.svg";